import React from 'react';
import styled from 'styled-components';
import incomeIcon from '#app/assets/icons/business_income.svg';
import outcomeIcon from '#app/assets/icons/chart_square.svg';

const TransactionItemContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 0;
  background: #fff;
  border-top: 1px solid #D7DBE0;
`;

const TransactionLeft = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
`;

const TransactionIcon = styled.img`
  width: 24px;
  height: 24px;
  object-fit: contain;
`;

const TransactionInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

const TransactionTitle = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color:rgb(0, 0, 0);
`;

const TransactionSubTitle = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: #7F818D;
`;


const TransactionRight = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

const TransactionAmount = styled.div<{ type: 'income' | 'outcome' }>`
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: ${props => props.type === 'income' ? '#36B2AB' : '#EF5E70'};
`;

interface Props {
  title: string;
  date: string;
  amount: string;
  change?: string;
  type?: 'income' | 'outcome';
  currency?: string;
  description?: string;
  isHighlighted?: boolean;
}

const TransactionItem: React.FC<Props> = ({ 
  title, 
  date, 
  amount, 
  change, 
  type = 'income',
  currency = '₽',
  description = '',
}) => {
  const isOutcome = type === 'outcome';
  
  return (
    <TransactionItemContainer>
      <TransactionLeft>
        <TransactionIcon src={type === 'income' ? incomeIcon : outcomeIcon} alt={type} />
        <TransactionInfo>
        <TransactionSubTitle>{date}</TransactionSubTitle>
        <TransactionTitle>{title}</TransactionTitle>
        <TransactionSubTitle>{description}</TransactionSubTitle>
        </TransactionInfo>
      </TransactionLeft>
      
      <TransactionRight>
        <TransactionAmount type={type}>
          {isOutcome ? '-' : ''}{amount}{currency}
        </TransactionAmount>
        {change && (
          <TransactionSubTitle>
            {change}
          </TransactionSubTitle>
        )}
      </TransactionRight>
    </TransactionItemContainer>
  );
};

export default TransactionItem;

